module.exports = __webpack_public_path__ + "fonts/Poppins-ExtraBold.c2cc929.ttf";